var l = /* @__PURE__ */ ((e) => (e.None = "none", e.Text = "text", e.Tel = "tel", e.Url = "url", e.Email = "email", e.Numeric = "numeric", e.Decimal = "decimal", e.Search = "search", e.DateTimeLocal = "datetime-local", e))(l || {});
const a = [
  "none",
  "text",
  "tel",
  "url",
  "email",
  "numeric",
  "decimal",
  "search",
  "datetime-local"
];
export {
  a as INPUT_MODES,
  l as InputMode
};
